import { SortDirection } from "../common";
import { environmentHttpClient } from "client/Api/httpClient";

export const enum AuditLogSortProperty {
	EventTime = 0,
	Upn = 1
};

export type AuditLogOrderModel = {
	property: AuditLogSortProperty;
	direction: SortDirection;
};

export type AuditLogItemModel = {
	id: number;
	eventTime: string;
	userUpn: string;
	actionDescription: string;
};

export function list(
	order: AuditLogOrderModel,
	pageSize: number,
	skip: number,
	signal?: AbortSignal
): Promise<PageResult<AuditLogItemModel>> {
	return environmentHttpClient.get<PageResult<AuditLogItemModel>>(
		"/UiApi/AuditLogs/List",
		{
			pageSize,
			skip,
			order
		},
		{ signal }
	);
}